import { DataTypes } from "@lexriver/data-types"

export enum EnumSortDirection{
    Asc = 'asc',
    Desc = 'desc'
}

export function convertStringToEnumSortDirection(x:string|undefined, defaultValue:EnumSortDirection){
    if(DataTypes.isValueExistsInEnum(x, EnumSortDirection)){
        return x as EnumSortDirection
    }
    return defaultValue
}

